<template>
  <Table ref="table" :columns="columns" :data="list">
    <template slot-scope="{ row }" slot="contact">
      {{ row.name }} <span v-if="row.contact">({{ row.contact }})</span>
    </template>
    
    <template slot-scope="{ row }" slot="address">
      {{ row.address }} {{ row.number }}, {{ row.house }} {{ row.zip }} {{ row.city }}
    </template>

    <template slot-scope="{ row }" slot="type">
      <Tag v-if="row.type" color="primary">{{ $t('name.address.type') }}</Tag>
    </template>
    
    <template slot-scope="{ row }" slot="created_at">
      <Time :time="row.created_at * 1000" type="date" />
    </template>

    <template slot-scope="{ row }" slot="action">
      <Poptip
        confirm
        :title="$t('name.delete_confirm')"
        @on-ok="onDelete(row)"
      >
        <a>{{ $t('name.delete') }}</a>
      </Poptip>
    </template>
  </Table>
</template>
<script>
import { del } from '@/api/address';

export default {
  props: {
    list: Array,
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("name.address.contact"),
          slot: "contact"
        },
        {
          title: this.$t("name.address.phone"),
          key: "phone",
        },
        {
          title: this.$t("name.address.email"),
          key: 'email'
        },
        {
          title: this.$t("name.address.address"),
          slot: 'address',
          width: 380
        },
        {
          title: this.$t("name.address.type"),
          slot: 'type',
          align: 'center'
        },
        {
          title: this.$t("name.address.created_at"),
          slot: 'created_at',
          align: 'center',
          width: 180,
        },
        {
          title: this.$t("name.active"),
          slot: 'action',
          width: 120,
          fixed: 'right'
        },
      ]
    };
  },
  methods: {
    onDelete(data) {
      del(data.id).then(res => {
        this.$emit('get')
        this.$Message.success(this.$t('message.' + res.message))
      }).catch(res => {
        this.$Message.error(this.$t('message.' + res.message))
      })
    }
  }
};
</script>